import { ASSETS } from "@/lib/content";

const FOOTER_LINKS = [
  { label: "How it works", href: "#how-it-works" },
  { label: "Features", href: "#features" },
  { label: "Support", href: "#support" },
  { label: "Privacy", href: "#privacy" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="mt-12 rounded-t-[3rem] bg-[#064e3b] px-8 py-16 text-white"
    >
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img src={ASSETS.appIcon} alt="Purrse" className="h-12 w-12 rounded-xl" />
              <span className="font-heading text-2xl font-extrabold">Purrse</span>
            </div>
            <p className="mt-4 text-emerald-100/80">
              Your money, but make it purr. A joyful, guilt-free way to spend on what lights you up.
            </p>
          </div>

          <nav className="flex flex-col gap-3">
            <p className="font-heading text-sm font-bold uppercase tracking-widest text-emerald-300/80">
              Explore
            </p>
            {FOOTER_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`footer-link-${l.href.replace("#", "")}`}
                className="text-emerald-100/90 transition-colors hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-8 text-sm text-emerald-100/60 sm:flex-row">
          <p>© {new Date().getFullYear()} Purrse. All rights reserved.</p>
          <p>Made with care, and a little side eye, by Bast.</p>
        </div>
      </div>
    </footer>
  );
};
